<template>
  <b-row class="create-order">
    <b-col cols="12" md="6">
      <div class="h__100 w__100 preview">
        <div>
          <b-container fluid>
            <h2 class="f--20 m__b--20 m__t--18">
              Customer Order
            </h2>

            <b-card>
              <span class="f--24 bold p__t--20 p__b--20">Harga Total</span>
              <hr />
              <div class="date-preview">
                <div class="m__t--20 tanggal">
                  {{ new Date() | moment('DD MMMM YYYY') }}
                </div>

                <div class="m__b--20 jam">
                  {{ new Date() | moment('hh:mm:ss') }} WIB
                </div>
              </div>

              <hr />
              <div class="f--14 p__t--20 p__b--20">
                <b-row>
                  <b-col>
                    {{ itemData.total_normal }} Tiket Orang Dewasa
                  </b-col>
                  <b-col>
                    <vue-autonumeric
                      class="autonumeric-field"
                      v-model="price"
                      tag="span"
                      :options="{
                        readOnly: true,
                        digitGroupSeparator: '.',
                        decimalCharacter: ',',
                        decimalCharacterAlternative: '.',
                        currencySymbol: 'Rp.\u00a0',
                        currencySymbolPlacement: 'p',
                        roundingMethod: 'U',
                        minimumValue: '0'
                      }"
                      placeholder="Enter Price"
                    />
                  </b-col>
                </b-row>
              </div>
              <hr />
              <div class="f--14 p__t--20 p__b--20">
                <b-row>
                  <b-col> {{ itemData.total_kid }} Tiket Anak-anak </b-col>
                  <b-col>
                    <vue-autonumeric
                      class="autonumeric-field"
                      v-model="kid_price"
                      tag="span"
                      :options="{
                        readOnly: true,
                        digitGroupSeparator: '.',
                        decimalCharacter: ',',
                        decimalCharacterAlternative: '.',
                        currencySymbol: 'Rp.\u00a0',
                        currencySymbolPlacement: 'p',
                        roundingMethod: 'U',
                        minimumValue: '0'
                      }"
                      placeholder="Enter Price"
                    />
                  </b-col>
                </b-row>
              </div>

              <hr />
            </b-card>
            <b-row class="m__t--34">
              <b-col cols="6" class="m__b--16">
                <b-row>
                  <b-col>
                    Sub Total
                  </b-col>
                  <b-col cols="8">
                    <div class="float-to-left">
                      :
                      <vue-autonumeric
                        class="autonumeric-field"
                        v-model="subtotal_price"
                        tag="span"
                        :options="{
                          readOnly: true,
                          digitGroupSeparator: '.',
                          decimalCharacter: ',',
                          decimalCharacterAlternative: '.',
                          currencySymbol: 'Rp.\u00a0',
                          currencySymbolPlacement: 'p',
                          roundingMethod: 'U',
                          minimumValue: '0'
                        }"
                        placeholder="Enter Price"
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6" class="m__b--16">
                <b-row>
                  <b-col>
                    Total
                  </b-col>
                  <b-col cols="8">
                    <div class="float-to-left">
                      <vue-autonumeric
                        class="autonumeric-field f--20 bold"
                        v-model="total_price"
                        tag="span"
                        :options="{
                          readOnly: true,
                          digitGroupSeparator: '.',
                          decimalCharacter: ',',
                          decimalCharacterAlternative: '.',
                          currencySymbol: 'Rp.\u00a0',
                          currencySymbolPlacement: 'p',
                          roundingMethod: 'U',
                          minimumValue: '0'
                        }"
                        placeholder="Enter Price"
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6" class="m__b--16">
                <b-row>
                  <b-col>
                    Discount
                  </b-col>
                  <b-col cols="8">
                    : 0
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6"> </b-col>
              <b-col cols="6">
                <b-row>
                  <b-col>
                    Tax
                  </b-col>
                  <b-col cols="8">
                    : 0
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <div class="float-to-right m__t--40">
              <b-button @click="save">
                <i class="fa fa-print"></i> Print Ticket
              </b-button>
            </div>
          </b-container>
        </div>
      </div>
    </b-col>

    <b-col cols="12" md="6">
      <div class="h__100 w__100 input-order">
        <b-container fluid>
          <div class="p__t--65">
            <h2 class="c--white f--24">
              Tiket Masuk
              {{ attractionState.detail ? attractionState.detail.name : '-' }}
            </h2>

            <p class="f--16 c--white">
              {{ new Date() | moment('DD MMMM YYYY hh:mm:ss') }} WIB
            </p>

            <b-form class="m__t--40">
              <label class="c--white"> Date </label>
              <date-pick
                v-model="itemData.checkin_date"
                placeholder="Select date"
              ></date-pick>

              <br />
              <br />

              <label class="c--white">Name</label>
              <b-form-input
                v-model="itemData.contact_name"
                placeholder="Name"
              />

              <label class="c--white">Email</label>
              <b-form-input
                v-model="itemData.contact_email"
                type="email"
                placeholder="Email"
              />

              <label class="c--white">Contact</label>
              <b-form-input
                v-model="itemData.contact_phone"
                type="number"
                placeholder="Phone"
              />
            </b-form>

            <h3 class="c--white m__t--77 f--24 m__b--16">
              Berapa banyak orang yang akan masuk ?
            </h3>

            <div class="float-to-left c--white m__b--50">
              <div class="m__r--77">
                Orang Dewasa
                <br />
                <br />

                <div class="button-adding">
                  <span @click="minus('normal')">-</span
                  ><span class="center-span"> {{ itemData.total_normal }}</span
                  ><span class="cursor-pointer" @click="plus('normal')">+</span>
                </div>
              </div>
              <div>
                Anak-anak
                <br />
                <br />
                <div class="button-adding">
                  <span class="cursor-pointer" @click="minus('kid')">-</span
                  ><span class="center-span">{{ itemData.total_kid }}</span
                  ><span class="cursor-pointer" @click="plus('kid')">+</span>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'create-order',

  data() {
    return {
      itemData: {
        date: null,
        total_normal: 0,
        total_kid: 0,
        order_type: 'A',
        package_id: null,
        attraction_id: null,
        quantity: 0,
        total: 0,
        checkin_date: null,
        contact_name: '',
        contact_email: '',
        contact_phone: ''
      }
    };
  },
  computed: {
    ...mapState('StoreAttraction', ['attractionState']),
    ...mapState('StoreOrder', ['orderState']),
    generateData() {
      return {
        date: this.$moment(new Date()).format('YYYY-MM-DD'),
        order_type: 'A',
        package_id: null,
        attraction_id: this.$route.params.id,
        quantity: this.itemData.total_kid + this.itemData.total_normal,
        total: this.total_price,
        checkin_date: this.$moment(this.itemData.checkin_date).format(
          'YYYY-MM-DD'
        ),
        contact_name: this.itemData.contact_name,
        contact_email: this.itemData.contact_email,
        contact_phone: this.itemData.contact_phone
      };
    },
    price() {
      if (this.attractionState.detail) {
        return this.itemData.total_normal * this.attractionState.detail.price;
      }
      return 0;
    },
    kid_price() {
      if (this.attractionState.detail) {
        return this.itemData.total_kid * this.attractionState.detail.kid_price;
      }
      return 0;
    },
    discount() {
      return 0;
    },
    tax() {
      return 0;
    },
    subtotal_price() {
      return this.price + this.kid_price;
    },
    total_price() {
      return this.subtotal_price - this.discount + this.tax;
    }
  },
  watch: {
    'orderState.created'() {
      window.print();
    }
  },
  methods: {
    plus(data) {
      this.itemData['total_' + data] += 1;
    },
    save() {
      this.$store.dispatch('StoreOrder/createOrder', this.generateData);
    },
    minus(data) {
      if (this.itemData['total_' + data] !== 0) {
        this.itemData['total_' + data] -= 1;
      }
    }
  },
  created() {
    this.$store.dispatch('StoreAttraction/detailAttraction', {
      id: this.$route.params.id
    });
  }
};
</script>

<style lang="scss">
.c--white {
  color: white;
}

.vdp-datepicker__calendar .cell.selected {
  color: #fff;
  background: #1d2d4e !important;
}
.create-order {
  height: 100%;
  .col-12 {
    padding: 0px !important;
  }

  .date-preview {
    .tanggal {
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 37px;
      color: #1d2d4e;
    }
    .jam {
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 0px;
      color: #1d2d4e;
    }
  }

  .autonumeric-field {
    border: unset;
    height: unset;
    padding: 0px;
    padding-left: 5px;
  }

  .button-adding {
    span {
      text-align: center;
      padding: 20px;
      float: left;
      /* height: 50px;
    width: 50px; */
      border: 1px solid white;
      background: transparent;
    }
  }
  .center-span {
    float: left;
    width: 70px;
  }
  .preview {
    button {
      background: #0095e9;
      border-radius: 3px;
      border: unset;
      padding: 10px;
    }
  }
  .input-order {
    background: #1d2d4e;
    /* color: #fff; */
  }
}
</style>
